import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { tenantLookup } from './tenantLookup';

// Piso de tiempo de la respuesta, en ms.
//
// Sin él, la rama "la cuenta existe" hace un round-trip extra a Identity
// Platform y la rama "no existe" no: la diferencia se ve en la pestaña de red
// y delata qué correos están registrados. Es lo único que sobrevive del
// `setTimeout(1200)` que tenía este modal cuando solo fingía enviar — ahora
// con una razón.
const PISO_DE_TIEMPO_MS = 800;

/**
 * Pide el correo para restablecer la contraseña.
 *
 * 🚨 **Nunca falla hacia la UI, y nunca revela si la cuenta existe.** El
 * `tenant-lookup` responde 200 siempre (contrato §3) y esta función mantiene
 * esa propiedad de punta a punta: quien la llama muestra el mismo mensaje pase
 * lo que pase. Los fallos reales (red, cuota) quedan en la consola.
 *
 * El `tenantId` es imprescindible: en Identity Platform multi-tenant el
 * usuario vive DENTRO del tenant, así que pedir el correo sin fijar el silo no
 * encuentra la cuenta. Es el mismo paso que hace funcionar el login.
 */
export async function solicitarRestablecimiento(email: string): Promise<void> {
  const trabajo = (async () => {
    const tenantIdPrevio = auth.tenantId;
    try {
      const { identityPlatformTenantId } = await tenantLookup(email);
      if (!identityPlatformTenantId) {
        // La cuenta no está. No se llama a Firebase EN ABSOLUTO: así no hay
        // un error que atrapar ni que se escape distinguible a la consola.
        return;
      }
      auth.tenantId = identityPlatformTenantId;
      await sendPasswordResetEmail(auth, email);
    } catch (err) {
      console.warn('[auth] no se pudo pedir el restablecimiento', err);
    } finally {
      // Devolver el singleton a su sitio. Hoy este modal solo se abre desde
      // el login (donde tenantId era null), pero dejar mutado un global es
      // una bomba para el día que se abra desde otro punto.
      auth.tenantId = tenantIdPrevio;
    }
  })();

  await Promise.all([trabajo, new Promise(r => setTimeout(r, PISO_DE_TIEMPO_MS))]);
}
